import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  CreateTicket,
  MatchMemberFailed,
  MatchMemberSuccess,
  RemoveMember,
  SearchFieldChanged,
  TicketAssigneeChanged,
  TicketBodyChanged,
  TicketCategoryChanged,
  TicketCountryChanged,
  TicketSeverityChanged,
  TicketStatusChanged,
  TicketSubjectChanged,
  ToggleExecuteFlow,
  UpdateTicket,
} from '../actions/edit-ticket.actions';
import { CloseEditTicket, EditTicket, OpenTicketNav } from '../actions/tickets-search.actions';
import { TicketEditState } from '../models/tickets.models';

const initialState: TicketEditState = {
  isCreateNewTicket: true,
  ticket: [],
  ticketCategoryValues: [],
  ticketCategory: 0,
  ticketStatusValues: [],
  ticketStatus: 0,
  ticketAssigneeValues: [],
  ticketAssignee: 0,
  ticketSeverityValues: [],
  ticketSeverity: 0,
  subject: '',
  countryValues: [],
  country: 0,
  body: '',
  searchField: '',
  customerAdded: false,
  memberColumns: [],
  member: [],
  submit: false,
};

export const TicketEditReducer = createReducer(
  initialState,
  on(OpenTicketNav, (state, { categories, countries, memberColumns }) => ({
    ...state,
    ticketCategoryValues: categories,
    countryValues: countries,
    memberColumns,
  })),
  on(TicketSeverityChanged, (state, { ticketSeverity }) => ({
    ...state,
    ticketSeverity,
  })),
  on(TicketStatusChanged, (state, { ticketStatus }) => ({
    ...state,
    ticketStatus,
  })),
  on(TicketCountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(TicketCategoryChanged, (state, { ticketCategory }) => ({
    ...state,
    ticketCategory,
  })),
  on(TicketAssigneeChanged, (state, { ticketAssignee }) => ({
    ...state,
    ticketAssignee,
  })),
  on(SearchFieldChanged, (state, { searchField }) => ({
    ...state,
    searchField,
  })),
  on(TicketBodyChanged, (state, { body }) => ({
    ...state,
    body,
  })),
  on(TicketSubjectChanged, (state, { subject }) => ({
    ...state,
    subject,
  })),
  on(
    EditTicket,
    (
      state,
      {
        element,
        categories,
        countries,
        memberColumns,
        statusValues,
        ticketAssigneeValues,
        ticketSeverityValues,
      },
    ) => ({
      ...state,
      isCreateNewTicket: false,
      ticket: [element],
      ticketCategoryValues: categories,
      ticketCategory: element.ticketCategoryId,
      ticketStatusValues: statusValues,
      ticketStatus: element.ticketStatusId,
      ticketSeverity: element.ticketSeverityId,
      ticketAssigneeValues,
      ticketSeverityValues,
      ticketAssignee: element.ticketAssigneeId,
      subject: element.subject,
      countryValues: countries,
      country: element.countryId,
      memberColumns,
      body: element.body,
      customerAdded:
        element.ticketCustomer && Object.keys(element.ticketCustomer).length ? true : false,
      member: [element.ticketCustomer],
    }),
  ),
  on(MatchMemberSuccess, (state, { res }) => ({
    ...state,
    customerAdded: true,
    member: res,
  })),
  on(RemoveMember, MatchMemberFailed, (state) => ({
    ...state,
    customerAdded: false,
    member: [],
  })),
  on(CreateTicket, UpdateTicket, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, CloseEditTicket, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
  on(ToggleExecuteFlow, (state, { isExecuteFlowChecked }) => ({
    ...state,
    ticket: state.ticket.map((ticket) => ({
      ...ticket,
      executeFlow: isExecuteFlowChecked,
    })),
  })),
);
